import { render } from "./ReservationStatus.vue?vue&type=template&id=580be540"
import script from "./ReservationStatus.vue?vue&type=script&lang=js"
export * from "./ReservationStatus.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__